
import {store} from '../../store/index.js';

export default {
    install(vue, opts)
    {
        vue.apiUrl = (uri) => window.config.apiUrl.replace(/\/$/, '') + '/api/' + String(uri).replace(/^\//, '');
        vue.apiGet = (uri, data, options) => vue.apiRequest('GET', uri, data, options);
        vue.apiPost = (uri, data, options) => vue.apiRequest('POST', uri, data, options);
        vue.apiPut = (uri, data, options) => vue.apiRequest('PUT', uri, data, options);
        vue.apiPatch = (uri, data, options) => vue.apiRequest('PATCH', uri, data, options);
        vue.apiDelete = (uri, data, options) => vue.apiRequest('DELETE', uri, data, options);

        vue.api = {
            url: (uri) => vue.apiUrl(uri),
            get: (uri, data, options) => vue.apiRequest('GET', uri, data, options),
            post: (uri, data, options) => vue.apiRequest('POST', uri, data, options),
            put: (uri, data, options) => vue.apiRequest('PUT', uri, data, options),
            patch: (uri, data, options) => vue.apiRequest('PATCH', uri, data, options),
            delete: (uri, data, options) => vue.apiRequest('DELETE', uri, data, options)
        };

        /**
         * [description]
         * @param  {[type]} method [description]
         * @param  {[type]} uri    [description]
         * @param  {[type]} data   [description]
         * @return {[type]}        [description]
         */
        vue.apiRequest = (method, uri, data, options) => {
            options = vue.buildOptions(options);

            options.before();

            axios({
                url: vue.apiUrl(uri),
                data: data,
                method: method,
                cancelToken: window.AuthorizationCancelSource.token
            }).then(response => {
                if (typeof response.data.error != 'undefined') {
                    options.errorMessage(response.data.message);
                    options.error();
                    options.always();
                } else {
                    options.always();
                    options.callback(response.data);
                }
            }).catch(e => {
                options.error();
                options.always();
            });
        }

        /**
         * [description]
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
        vue.buildOptions = (options) => {
            if (typeof options === 'undefined') {
                options = {};
            }

            var functions = ['before', 'callback', 'error', 'always'];
            for (var i in functions) {
                var name = functions[i];
                if (typeof options[name] === 'undefined') {
                    options[name] = function() {};
                }
            }

            options.errorMessage = function(message) {
                alert(message);
            }

            return options;
        }

        // /**
        //  * [description]
        //  * @param  {[type]} options [description]
        //  * @return {[type]}         [description]
        //  */
        // vue.buildHeaders = (options) => {
        //     if (typeof options.public === 'undefined') {
        //         return {
        //             'Authorization': 'Bearer ' + store.getters.getToken
        //         };
        //     }
        //     return {};
        // }
    }
}
